import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

const ACTOR_LABEL = {
  platform_agent: "Platform Agent",
  abuse_filter: "Abuse Filter",
  voice_agent: "Voice Agent",
  trend_agent: "Trend Agent",
  approval_gate: "Approval Gate",
  summary_agent: "Summary Agent",
  author: "You",
  emergency: "Emergency",
};

const ACTOR_COLOR = {
  abuse_filter: "var(--elle-oxblood-bright)",
  approval_gate: "var(--elle-amber)",
  emergency: "var(--elle-oxblood-bright)",
  author: "var(--elle-amber-bright)",
};

export default function DecisionLog() {
  const [entries, setEntries] = useState([]);
  const [filter, setFilter] = useState("");

  const load = async () => {
    const { data } = await api.get("/decision-log", { params: { limit: 200, actor: filter || undefined } });
    setEntries(data);
  };
  useEffect(() => { load(); }, [filter]);

  return (
    <div data-testid="decision-log-page">
      <div className="mb-8">
        <div className="overline">Audit trail</div>
        <h1 className="font-display text-4xl mt-2">Decision log.</h1>
        <p className="mt-2 text-sm max-w-2xl" style={{ color: "var(--elle-ink-dim)" }}>
          Read-only. Every significant action by every agent and every author decision. Retained indefinitely.
        </p>
      </div>

      <div className="mb-5 flex gap-2 flex-wrap">
        <button onClick={()=>setFilter("")} data-testid="filter-all"
                className={`px-3 py-1 text-xs rounded-sm border ${!filter ? "border-[var(--elle-amber)] text-[var(--elle-amber)]" : "border-[var(--elle-border)] text-[var(--elle-ink-dim)]"}`}>
          All
        </button>
        {Object.entries(ACTOR_LABEL).map(([k, v]) => (
          <button key={k} onClick={()=>setFilter(k)} data-testid={`filter-${k}`}
                  className={`px-3 py-1 text-xs rounded-sm border ${filter === k ? "border-[var(--elle-amber)] text-[var(--elle-amber)]" : "border-[var(--elle-border)] text-[var(--elle-ink-dim)]"}`}>
            {v}
          </button>
        ))}
      </div>

      <div className="elle-surface rounded-sm overflow-hidden">
        <table className="w-full text-sm font-mono-elle">
          <thead>
            <tr className="text-left" style={{ background: "var(--elle-surface-2)" }}>
              <th className="px-4 py-3 overline">Time</th>
              <th className="px-4 py-3 overline">Actor</th>
              <th className="px-4 py-3 overline">Action</th>
              <th className="px-4 py-3 overline">Rationale</th>
              <th className="px-4 py-3 overline">Outcome</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((e) => (
              <tr key={e.id} data-testid={`log-${e.id}`}
                  className="border-t" style={{ borderColor: "var(--elle-border)" }}>
                <td className="px-4 py-3 text-xs whitespace-nowrap"
                    style={{ color: "var(--elle-ink-dim)" }}>
                  {new Date(e.timestamp).toLocaleString()}
                </td>
                <td className="px-4 py-3 whitespace-nowrap"
                    style={{ color: ACTOR_COLOR[e.actor] || "var(--elle-ink)" }}>
                  {ACTOR_LABEL[e.actor] || e.actor}
                </td>
                <td className="px-4 py-3" style={{ color: "var(--elle-ink)" }}>{e.action}</td>
                <td className="px-4 py-3" style={{ color: "var(--elle-ink-dim)" }}>{e.rationale}</td>
                <td className="px-4 py-3" style={{ color: "var(--elle-ink-dim)" }}>{e.outcome || "—"}</td>
              </tr>
            ))}
            {entries.length === 0 && (
              <tr><td colSpan={5} className="px-4 py-8 text-center"
                      style={{ color: "var(--elle-ink-faint)" }}>No entries.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
